import { createContext, useContext, type ReactNode } from 'react';
import { en, type Copy } from './en';

const CopyContext = createContext<Copy>(en);

/** Supplies the copy catalogue. English only for now; another language is another object of the same shape. */
export function CopyProvider({ copy = en, children }: { copy?: Copy; children: ReactNode }) {
  return <CopyContext.Provider value={copy}>{children}</CopyContext.Provider>;
}

/** The visible text for the Web MMS. Components never hard-code wording. */
export function useCopy(): Copy {
  return useContext(CopyContext);
}

export { en, type Copy };
